import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import { PhxAlertModule } from '../alert-banner/phx-alert.module';
import { PhxToastComponent } from './phx-toast.component';
import { PhxToastContainerComponent } from './phx-toast-container.component';
import { PhxToastService } from './phx-toast.service';

@NgModule({
  declarations: [PhxToastComponent, PhxToastContainerComponent],
  imports: [CommonModule, PhxAlertModule, OverlayModule],
  exports: [PhxToastComponent, PhxToastContainerComponent],
  providers: [PhxToastService],
})
export class PhxToastModule {}
